import { render, staticRenderFns } from "./noauthority.vue?vue&type=template&id=9d104fb8&scoped=true&"
import script from "./noauthority.vue?vue&type=script&lang=ts&"
export * from "./noauthority.vue?vue&type=script&lang=ts&"
import style0 from "./noauthority.vue?vue&type=style&index=0&id=9d104fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d104fb8",
  null
  
)

export default component.exports